import script from "./motion-in-order-modal.vue?vue&type=script&lang=js"
export * from "./motion-in-order-modal.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__